<nav class="ss-tabs-slider" [class.ss-tabs-slider--compact]="compact">
  <button
    *ngIf="canScrollLeft || canScrollRight"
    type="button"
    class="ss-tabs-navigation"
    aria-label="Abas anteriores"
    [disabled]="!canScrollLeft"
    (click)="scroll(-1)">
    <lucide-icon name="chevron-left" aria-hidden="true"></lucide-icon>
  </button>

  <div #strip class="ss-tabs-container" role="tablist" (scroll)="measure()" (keydown)="navigate($event)">
    <ng-container *ngFor="let tab of items">
      <ng-container *ngIf="!tab.permission; else permissionTab">
        <ng-container *ngTemplateOutlet="tabButton; context: { $implicit: tab }"></ng-container>
      </ng-container>
      <ng-template #permissionTab>
        <ng-template [ssHasPermission]="tab.permission" [ssHasPermissionAction]="tab.permissionAction">
          <ng-container *ngTemplateOutlet="tabButton; context: { $implicit: tab }"></ng-container>
        </ng-template>
      </ng-template>
    </ng-container>
  </div>

  <button
    *ngIf="canScrollLeft || canScrollRight"
    type="button"
    class="ss-tabs-navigation"
    aria-label="Próximas abas"
    [disabled]="!canScrollRight"
    (click)="scroll(1)">
    <lucide-icon name="chevron-right" aria-hidden="true"></lucide-icon>
  </button>
</nav>

<ng-template #tabButton let-tab>
  <button
    type="button"
    role="tab"
    class="ss-tab"
    [class.is-active]="isTabActive(tab.id)"
    [disabled]="tab.isDisabled"
    [attr.aria-selected]="isTabActive(tab.id)"
    [attr.tabindex]="isTabActive(tab.id) ? 0 : -1"
    (click)="changeTab(tab.id, tab.isDisabled)">
    {{ tab.name }}
  </button>
</ng-template>
